import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '../ui/dialog';
import { ApplicationForm } from './ApplicationForm';

export const ApplyDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="w-[calc(100%-1.5rem)] max-w-lg overflow-hidden rounded-[28px] border-line bg-navy p-0 text-white sm:rounded-[28px] [&>button]:right-5 [&>button]:top-5 [&>button]:z-10 [&>button]:text-white"
                   data-testid="apply-dialog">
      <DialogTitle className="sr-only">Deine Bewerbung</DialogTitle>
      <DialogDescription className="sr-only">Bewirb dich in wenigen Schritten für das 1:1 Aktien-Mentoring.</DialogDescription>
      <div className="max-h-[92vh] overflow-y-auto"><ApplicationForm bare /></div>
    </DialogContent>
  </Dialog>
);
